import {
  CompletionConfigurationResponse,
  CompletionPromptConfigurationOption,
} from 'types/api-responses';

// Backend MIME types (configurations_controller.rb) → file extensions the Carbon
// uploader accepts. Shared by the add-document modal and side panel.
export const MIME_TO_EXTENSIONS: Record<string, string[]> = {
  'application/pdf': ['.pdf'],
  'image/tiff': ['.tif', '.tiff'],
  'image/tif': ['.tif', '.tiff'],
  'text/csv': ['.csv'],
  'application/xml': ['.xml'],
  'text/xml': ['.xml'],
};

// Unique file extensions for the given MIME types.
export const extensionsFromMimeTypes = (mimeTypes: string[]): string[] => [
  ...new Set(mimeTypes.flatMap((mime) => MIME_TO_EXTENSIONS[mime] ?? [])),
];

// Formats accepted when a document type doesn't specify its own.
export const DEFAULT_ACCEPTED_FORMATS = ['application/pdf', 'image/tiff'];

export function getPromptsForDocumentType(
  allPrompts: CompletionPromptConfigurationOption[],
  promptCategory: string
): CompletionPromptConfigurationOption[] {
  return allPrompts.filter((p) => p.category === promptCategory);
}

export function getDefaultPrompt(
  prompts: CompletionPromptConfigurationOption[]
): CompletionPromptConfigurationOption | undefined {
  return prompts.find((p) => p.default) || prompts[0];
}

export function getFormDefaults(
  configurationOptions: CompletionConfigurationResponse
) {
  const extractionConfigurations =
    configurationOptions.extractionConfigurations.filter((el) => el.default)[0];
  const completionConfigurations =
    configurationOptions.completionConfigurations.filter((el) => el.default)[0];

  return {
    extractionConfigurations,
    completionConfigurations,
  };
}
